<div class="wrapper-accounts-search-results">
    <div class="wrapper-custom-tabs-purple">
        <div class="custom-tab-purple" (click)="tabSelected = 'all'" [ngClass]="{'active': tabSelected === 'all'}">
            <span>
                {{'INSIGHTS.all' | translate}}
            </span>
        </div>
        <div class="custom-tab-purple" (click)="tabSelected = 'listers'"
            [ngClass]="{'active': tabSelected === 'listers'}">
            <img class="no-active" src="./assets/icons/outline/icon-user.svg" alt="">
            <img class="active" src="./assets/icons/fill/icon-user.svg" alt="">
            <span class="visibility-text">
                {{'NEAR_YOU_PAGE.listers' | translate}}
            </span>
        </div>
        <div class="custom-tab-purple" (click)="tabSelected = 'companies'"
            [ngClass]="{'active': tabSelected === 'companies'}">
            <img src="" alt="">
            <img class="no-active" src="./assets/icons/outline/icon-company.svg" alt="">
            <img class="active" src="./assets/icons/fill/icon-fill-company.svg" alt="">
            <span class="visibility-text">
                {{'SEARCH.companies' | translate}}
            </span>
        </div>
    </div>
    <div *ngIf="tabSelected === 'all'" class="wrapper-list-search-accounts">
        <span class="title-search-results">Users</span>
        <div *ngFor="let user of listers" class="wrapper-card-lister" [routerLink]="[PAGES_AND_PATHS.profile.pagePath, user.username]">
            <div class="wrapper-favorite-lister">
                <div class="wrapper-avatar">
                    <img [src]="user?.profile_photo_url ? user?.profile_photo_url : '../../../../assets/images/avatar-user.png'" alt="">
                </div>
                <div class="wrapper-user-info">
                    <div class="wrapper-username">
                        <span>{{user?.name ? user?.name : user?.username}}</span>
                        <img *ngIf="(user?.subscriptions | checkActiveRole) === UserRoles.expert" src="../../../assets/icons/fill/icon-badge.svg" alt="">
                      <img *ngIf="(user?.subscriptions | checkActiveRole) === UserRoles.company" src="../../../assets/icons/fill/icon-fill-company.svg" alt="">
                    </div>
                    <span>{{user?.followers_count}} {{user.followers_count === 1 ? ('GENERAL.followers' | translate) : ('GENERAL.followers' | translate)}}</span>
                </div>
            </div>
        </div>
        <span class="title-search-results">
            {{'SEARCH.companies' | translate}}
        </span>
        <div *ngFor="let company of companies" [routerLink]="[PAGES_AND_PATHS.profile.pagePath, company.username]" class="wrapper-card-lister">
            <div class="wrapper-favorite-lister">
                <div class="wrapper-avatar">
                    <img [src]="company?.profile_photo_url ? company?.profile_photo_url : './assets/images/avatar-user-expert.png'" alt="">
                </div>
                <div class="wrapper-user-info">
                    <div class="wrapper-username">
                        <span>{{company.username}}</span>
                        <img src="./assets/icons/fill/icon-fill-company.svg" alt="">
                    </div>
                    <span>{{company?.followers_count}} {{company.followers_count === 1 ? ('GENERAL.followers' | translate) : ('GENERAL.followers' | translate)}}</span>
                </div>
            </div>
        </div>
    </div>
    <app-listers *ngIf="tabSelected === 'listers'"  [searchTerm]="searchTerm" [isLiveSearch]="isLiveSearch"></app-listers>
    <app-companies *ngIf="tabSelected === 'companies'"  [searchTerm]="searchTerm" [isLiveSearch]="isLiveSearch"></app-companies>

</div>
